'use strict'

const { Plugin } = ProseMirror.state
const { fixHtmlForProseMirror } = require('../../../functions/fixHtmlForProseMirror.js')
const getComposedEventPath = require('../../../functions/getComposedEventPath.js')

function rmProseMirror ($scope, [$element]) {
    const pmComponent = document.createElement('pbx-prosemirror')
    $scope.pmComponent = pmComponent

    setTimeout(() => {
        $element.appendChild(pmComponent)
    })

    function updatePlugins () {
        const plugins = [
            new Plugin({
                props: {
                    handleDOMEvents: {
                        keyup: $scope.onKeyup,
                        blur: $scope.onBlur,
                        focus: $scope.onFocus,
                    },
                },
                view: () => ({
                    update () {
                        $scope.changeNgModel()
                        if (typeof $scope.onChange === 'function') {
                            $scope.onChange()
                        }
                    },
                }),
            }),
        ]

        if ($scope.plugins && Array.isArray($scope.plugins)) {
            plugins.push(...$scope.plugins)
        }

        pmComponent.plugins = plugins
    }

    function onClick (event) {
        const path = getComposedEventPath(event)
        if (path[0].nodeName === 'RM-PROSE-MIRROR') {
            pmComponent.view.focus()
        }
    }

    $element.classList.add('RmProseMirror-Container')
    $element.addEventListener('click', onClick)

    const pluginsWatcher = $scope.$watch('plugins', (newPlugins, oldPlugins) => {
        if (newPlugins !== oldPlugins) updatePlugins(newPlugins)
    })

    updatePlugins($scope.plugins)

    const pbxAttributeWatchers = []
    for (const pbxAttribute in pbxAttributes) {
        if (!pbxAttributes.hasOwnProperty(pbxAttribute)) continue
        pbxAttributeWatchers.push($scope.$watch(pbxAttribute, value => {
            if (value == null) value = pbxAttributes[pbxAttribute]
            pmComponent[pbxAttribute] = value
        }))
    }

    $scope.$on('$destroy', () => {
        pluginsWatcher()
        for (const pbxAttributeWatcher of pbxAttributeWatchers) {
            pbxAttributeWatcher()
        }

        $element.removeEventListener('click', onClick)
    })
}

const pbxAttributes = {
    hideMenuOnBlur: false,
    menuPosition: 'top',
}

module.exports = [() => {
    return {
        require: '?ngModel',
        controller: [
            '$scope',
            '$element',
            rmProseMirror,
        ],
        scope: {
            hideMenuOnBlur: '=',
            menuPosition: '=',
            plugins: '=',
            onFocus: '&',
            onBlur: '&',
            onKeyup: '&',
            onChange: '&',
        },
        link ($scope, element, attributes, ngModel) {
            $scope.changeNgModel = () => void 0

            $scope.noNgModel = !ngModel
            if ($scope.noNgModel) return

            $scope.changeNgModel = () => {
                ngModel.$setViewValue($scope.pmComponent.content)
            }

            ngModel.$render = () => {
                $scope.pmComponent.content = fixHtmlForProseMirror(ngModel.$modelValue) || ''
            }
        },
    }
}]
